//ACCOUNTS SEARCH TIMEOUT
export const timeout = 500;
